// pages/CompleterProfil.jsx
import { useState, useEffect } from "react";
import api from "../api";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

//import logo from "../images/logo.png";

const CompleterProfil = () => {
  const navigate = useNavigate();
  
 // const location = useLocation();
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const toArray = (value) => {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value.flatMap(v => {
      if (typeof v === "string") {
        try {
          const parsed = JSON.parse(v);
          return Array.isArray(parsed) ? parsed : [v];
        } catch {
          return [v];
        }
      }
      return v;
    });
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [value];
    } catch {
      return [value];
    }
  }

  return [];
};

  // Vérifier connexion
 useEffect(() => {
  if (!storedUser) {
    alert("Veuillez vous connecter.");
    navigate("/login");
  }
}, [storedUser, navigate]);


  const userId = storedUser?.id; // ← utilise l'ID depuis localStorage
  const [form, setForm] = useState({
    // Utiliser storedUser si disponible, sinon valeurs vides
    name: storedUser?.name || "",
    prenom: storedUser?.prenom || "",
    email: storedUser?.email || "",
    telephone: storedUser?.telephone || "",
    photo: storedUser?.photo || null,
    role: storedUser?.role || "particulier",
    // Champs créateur

    metier: storedUser?.metier || "",
    domaine: toArray(storedUser?.domaine),
    autresDomaines: [],
  langues: toArray(storedUser?.langues),
  

    nationalites: storedUser?.nationalites || "",
    video: storedUser?.video || "",
    description: storedUser?.description || "",
    valeurs: storedUser?.valeurs || "",
    lieuPrestation: storedUser?.lieuPrestation || "",    
   // pmr: storedUser?.pmr || false,
    typeCours: storedUser?.typeCours || "",
    liens: storedUser?.liens || "",
    siteWeb: storedUser?.siteWeb || "", 
    instagram: storedUser?.instagram || "",
    linkedin: storedUser?.linkedin || "",
  });


  const domaines = [
    "Animaux & monde vivant",
    "Architecture & urbanisme",
    "Artisanat",
    "Arts visuels",
    "Arts vivants",
    "Bien-être",
    "Décoration & aménagement",
    "Développement personnel",
    "Écologie & durabilité",
    "Écriture & littérature",
    "Entrepreneuriat & innovation",
    "Finances personnelles & économie",
    "Formation, enseignement & accompagnement",
    "Gastronomie & art culinaire",
    "Humanitaire & droits humains",
    "Inclusion & solidarité",
    "Informatique & numérique",
    "Jeux & expériences interactives",
    "Management & organisation",
    "Marketing & communication",
    "Médias, journalisme & storytelling",
    "Musique & son",
    "Nature, jardinage & permaculture",
    "Parentalité & famille",
    "Politique, citoyenneté & engagement sociétal",
    "Relations & développement social",
    "Santé",
    "Sciences & technologies",
    "Sport, loisirs physiques & outdoor",
    "Spiritualité",
    "Stylisme & mode",
    "Thérapies alternatives",
    "Voyage, tourisme & interculturalité",
    "Autres",
  ];

  const languesDisponibles = ["Français", "Anglais"];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    
    });
  };
  const handleDomaineChange = (value) => {
    setForm((prev) => {
      if (prev.domaine.includes(value)) {
        return {
          ...prev,
          domaine: prev.domaine.filter((d) => d !== value),
        };
      }

      const effectiveCount = [
        ...(prev.domaine.filter((d) => d !== "Autres")),
        ...((prev.autresDomaines || []).map((v) => v.trim()).filter(Boolean)),
      ].length;

      if (effectiveCount >= 10) {
        return prev;
      }

      return {
        ...prev,
        domaine: [...prev.domaine, value],
      };
    });
  };

  const handleLangueChange = (langue) => {
    setForm((prev) => ({
      ...prev,
      langues: prev.langues.includes(langue)
        ? prev.langues.filter((l) => l !== langue)
        : [...prev.langues, langue],
    }));
  };

  const addAutreDomaine = () => {
    setForm((prev) => {
      const effectiveCount = [
        ...(prev.domaine.filter((d) => d !== "Autres")),
        ...((prev.autresDomaines || []).map((v) => v.trim()).filter(Boolean)),
      ].length;

      if (effectiveCount >= 10) {
        return prev;
      }

      return {
        ...prev,
        autresDomaines: [...(prev.autresDomaines || []), ""],
      };
    });
  };

  const updateAutreDomaine = (index, value) => {
    setForm((prev) => ({
      ...prev,
      autresDomaines: (prev.autresDomaines || []).map((item, idx) => idx === index ? value : item),
    }));
  };

  const removeAutreDomaine = (index) => {
    setForm((prev) => ({
      ...prev,
      autresDomaines: (prev.autresDomaines || []).filter((_, idx) => idx !== index),
    }));
  };

  const profilePhotoPreview = form.photo
    ? (typeof form.photo === "string" ? form.photo : URL.createObjectURL(form.photo))
    : "";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId) return;

    const data = new FormData();

    let finalDomaine = [
      ...form.domaine.filter((c) => c !== "Autres"),
      ...((form.autresDomaines || []).map((v) => v.trim()).filter(Boolean)),
    ].slice(0, 10);


    Object.keys(form).forEach((key) => {
  let value = form[key];

  if (key === "autresDomaines") return;

  // ❌ ne pas envoyer champs créateur pour particulier
  if (
    form.role === "particulier" &&
    [
      "metier",
      "domaine",
      "langues",
      "nationalites",
      "video",
      "description",
      "valeurs",
      "lieuPrestation",
      "typeCours",
      "liens",
      "siteWeb",
      "instagram",
      "linkedin",
      "autreDomaine",
    ].includes(key)
  ) {
    return;
  }

  // domaine final
  if (key === "domaine") {
    value = finalDomaine;
  }

  // ❌ ne pas envoyer vide
  if (value === "" || value === null || value === undefined) return;

  if (Array.isArray(value)) {
    value.forEach((v) => data.append(key, v));
  } else {
    data.append(key, value);
  }
});


    try {
      const res = await api.put(`/api/auth/complete-profile/${userId}`, data);

      // ✅ stocker UNIQUEMENT la réponse backend
      if (res?.data?.user) {
        localStorage.setItem("user", JSON.stringify(res.data.user));
        localStorage.setItem("profileCompleted", "true");
      }

      navigate("/profile", { replace: true });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--app-background)' }}>
      <header className="p-4 border-b bg-white flex items-center">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="link-fuchsia hover:underline transition-colors text-sm"
        >
          ← Retour
        </button>
        {/* <img src={logo} alt="Logo" className="h-10 mx-auto" /> */}
      </header>

      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
            Bonjour {form.prenom}  {form.name}   👋 Complétez votre profil
          </h2>
          <p className="text-gray-600 mb-6">
            Veuillez compléter les informations suivantes pour finaliser votre
            profil.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Infos de base */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="tel"
                name="telephone"
                placeholder="Téléphone"
                value={form.telephone}
                onChange={handleChange}
                className="border border-gray-300 rounded-lg px-4 py-3"
              />

              <div className="rounded-2xl border border-dashed border-[var(--accent-primary)] bg-[var(--accent-primary-soft)] p-4">
                <div className="flex items-center gap-4">
                  <div className="w-20 h-20 rounded-full bg-white border-2 border-[var(--accent-primary)] overflow-hidden flex items-center justify-center text-[var(--accent-primary)] shadow-sm">
                    {profilePhotoPreview ? (
                      <img src={profilePhotoPreview} alt="Aperçu" className="w-full h-full object-cover" />
                    ) : (
                      <span className="text-2xl">📷</span>
                    )}
                  </div>

                  <div className="flex-1">
                    <p className="font-semibold text-gray-800">Photo de profil</p>
                    <p className="text-xs text-gray-600 mt-1">JPG, PNG ou WebP • jusqu’à 5 Mo</p>
                    <label className="inline-flex mt-3 items-center justify-center bg-[var(--accent-primary)] text-white rounded-full px-4 py-2 text-sm font-medium cursor-pointer hover:opacity-95 transition">
                      Choisir une photo
                      <input
                        type="file"
                        accept="image/*"
                        name="photo"
                        onChange={(e) => {
                          const selected = e.target.files?.[0] || null;
                          setForm((prev) => ({ ...prev, photo: selected }));
                        }}
                        className="hidden"
                      />
                    </label>
                    {form.photo && typeof form.photo !== "string" && (
                      <p className="text-xs text-gray-500 mt-2">Fichier sélectionné : {form.photo.name}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Champs Créateur */}
            {form.role === "createur" && (
              <div className="bg-gray-50 p-6 rounded-xl space-y-4">
                <h3 className="font-semibold text-gray-800">
                  Informations Créateur
                </h3>

                <input
                  type="text"
                  name="metier"
                  placeholder="Comment te définirais-tu en tant que Créateur"
                  value={form.metier}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />

                <div>
                  {" "}
                  <p className="text-gray-700 font-medium">
                    Domaines d’activité :
                  </p>{" "}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
                    {" "}
                    {domaines.map((d) => (
                      <label
                        key={d}
                        className="flex items-center gap-2 text-gray-700"
                      >
                        {" "}
                        <input
                          type="checkbox"
                          checked={form.domaine.includes(d)}
                          onChange={() => handleDomaineChange(d)}
                        />{" "}
                        {d}{" "}
                      </label>
                    ))}{" "}
                  </div>{" "}
                    {form.domaine.includes("Autres") && (
    <div className="mt-3 space-y-2">
      <div className="flex items-center justify-between">
        <label className="block text-gray-700 text-sm font-medium">
          Catégories libres supplémentaires
        </label>
        <button
          type="button"
          onClick={addAutreDomaine}
          className="text-xs text-[var(--accent-primary)] hover:underline"
        >
          + Ajouter
        </button>
      </div>

      {(form.autresDomaines || []).map((value, index) => (
        <div key={index} className="flex items-center gap-2">
          <input
            type="text"
            value={value}
            onChange={(e) => updateAutreDomaine(index, e.target.value)}
            placeholder="Ex : Coaching, Photographie..."
            className="w-full border border-gray-300 px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
          />
          <button
            type="button"
            onClick={() => removeAutreDomaine(index)}
            className="text-gray-500 hover:text-red-600 text-sm"
          >
            Retirer
          </button>
        </div>
      ))}

      {(!form.autresDomaines || form.autresDomaines.length === 0) && (
        <button
          type="button"
          onClick={addAutreDomaine}
          className="text-sm text-[var(--accent-primary)] hover:underline"
        >
          Ajouter une catégorie "Autres"
        </button>
      )}
    </div>
  )}

  {/* Message d'erreur si aucune catégorie sélectionnée */}
  {form.domaine.length === 0 && (
    <p className="text-red-500 text-sm mt-1">
      Veuillez sélectionner au moins une catégorie
    </p>
  )}
                </div>

                <div>
                  <p className="text-gray-700">Langues parlées :</p>
                  <div className="flex flex-wrap gap-4 mt-2">
                    {languesDisponibles.map((langue) => (
                      <label key={langue} className="flex items-center gap-1">
                        <input
                          type="checkbox"
                          checked={form.langues.includes(langue)}
                          onChange={() => handleLangueChange(langue)}
                        />{" "}
                        {langue}
                      </label>
                    ))}
                  </div>
                </div>

                <input
                  type="text"
                  name="nationalites"
                  placeholder="Nationalités"
                  value={form.nationalites}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />
                <input
                  type="url"
                  name="video"
                  placeholder="Lien vidéo de présentation "
                  value={form.video}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />
                <textarea
                  name="description"
                  placeholder="À propos de moi"
                  value={form.description}
                  onChange={handleChange}
                  rows="3"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />
                <textarea
                  name="valeurs"
                  placeholder="Mes valeurs profondes "
                  value={form.valeurs}
                  onChange={handleChange}
                  rows="2"
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                />
                <select
                  name="lieuPrestation"
                  value={form.lieuPrestation}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                >
                  <option value="">Type de prestation</option>
                  <option value="En ligne">Distanciel</option>
                  <option value="Présentiel">Présentiel</option>
                  <option value="Distanciel & Présentiel">Distanciel & Présentiel</option>

                </select>
             {/*    <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="pmr"
                    checked={form.pmr}
                    onChange={handleChange}
                  />
                  Accessible PMR (Personnes à mobilité réduite)
                </label>  */} 
                <select
                  name="typeCours"
                  value={form.typeCours}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
                >
                  <option value="">Type de séance</option>

                   <option value="Individuelle">Individuelle</option>
<option value="Collective">Collective</option>
<option value="Individuelle & Collective">
  Individuelle & Collective
</option>

                </select>
                <div className="space-y-3">
                  <p className="text-gray-700 font-medium">Liens</p>

                  <input
                    type="url"
                    name="siteWeb"
                    placeholder="Site Web"
                    value={form.siteWeb || ""}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-4 py-3"
                  />

                  <input
                    type="url"
                    name="instagram"
                    placeholder="Instagram"
                    value={form.instagram || ""}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-4 py-3"
                  />

                  <input
                    type="url"
                    name="linkedin"
                    placeholder="LinkedIn"
                    value={form.linkedin || ""}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-4 py-3"
                  />
                </div>
              </div>
            )}

            <button
              type="submit"
              className="w-full btn-primary py-3 font-semibold"
            >
              Compléter le profil
            </button>
          </form>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CompleterProfil;
